export const FailureModeSectionDataP615 = (formData) => {
    const asFoundResult = formData.F102AftResult === 'PASS';
    return {
        rows: [{
            key: 1,
            fields: [{
                key: 'F619AsLeftTestRequired',
                label: 'As-Left Test Required?',
                value: !(asFoundResult) ? formData.F619AsLeftTestRequired : '',
                isDisabled: asFoundResult,
                isRequired: false,
                isDropdown: !(asFoundResult),
                readOnly: asFoundResult,
                placeholder: 'Select YES or NO',
                options: [{ name: 'Select YES or NO', value: '' },
                { name: 'YES', value: 'YES' },
                { name: 'NO', value: 'NO' }],
                inputTextAlign: 'center',
                labelWidth: '51.5%',
                width: '48.5%',
                xs: 6,
                height: asFoundResult ? '1.26rem' : '1.55rem',
                marginTop: '15px',
                textAlign: 'left',
            }]
        }]
    };
};
